module.exports = __webpack_public_path__ + "static/img/割草机.39cccd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/割草机.jpg
// module id = wDou
// module chunks = 1